'use strict';

var scaleCorrection = require('../../projection/styles/scale-correction.cjs');
var keysTransform = require('../../../../../../../motion-dom/dist/es/render/utils/keys-transform.cjs');

function isForcedMotionValue(key, { layout, layoutId }) {
    return (keysTransform.transformProps.has(key) ||
        key.startsWith("origin") ||
        ((layout || layoutId !== undefined) &&
            (!!scaleCorrection.scaleCorrectors[key] || key === "opacity")));
}

exports.isForcedMotionValue = isForcedMotionValue;
//# sourceMappingURL=is-forced-motion-value.cjs.map
